import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import PropTypes from "prop-types";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import CssBaseline from "@mui/material/CssBaseline";
import useScrollTrigger from "@mui/material/useScrollTrigger";
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import Fab from "@mui/material/Fab";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import Fade from "@mui/material/Fade";
import IconButton from "@mui/material/IconButton";
import CheckIcon from "@mui/icons-material/Check";
import { estiloSegmento } from "../../estilos";
import { Segment, Header, Image, Grid } from "semantic-ui-react";
import Swal from "sweetalert2";
import { useFormik } from "formik";
import { initialValues } from "../../componentes/OlvidoSuClave";
import { validationSchema } from "../../componentes/OlvidoSuClave";
import { apiUsuario } from "../../api/usuario";
import { ENTORNO, HabilitarGoogleRecaptcha } from "../../utils/constantes";
import { setemail } from "../../utils/variablesLocales";
import {
  necesitas_ayuda_con_tu_contrasena,
  ingresa_el_correo_electronico_que_utilizas_en_local_point_y_te_ayudaremos_a_crear_una_nueva_contrasena,
  email,
  email_invalido,
  olvidaste_tu_contrasena,
} from "../../utils/traductor";
import { estiloColores } from "../../estilos/colores";
import imaLogo from "../../imagenes/logo.png";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { TextField } from "@mui/material";
import "../../scss/index.scss";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import animacion from "../../imagenes/AnimacionesVarias/LoadingMap.json";
import { Player } from "@lottiefiles/react-lottie-player";

import { apigoogleRecaptchaV3 } from "../../api";
import ReactRecaptcha3 from "react-google-recaptcha3";

const apigooglerecaptchav3 =
  HabilitarGoogleRecaptcha === true ? new apigoogleRecaptchaV3() : null;

function ScrollTop(props) {
  const { children, window } = props;
  // Note that you normally won't need to set the window ref as useScrollTrigger
  // will default to window.
  // This is only being set here because the demo is in an iframe.
  const trigger = useScrollTrigger({
    target: window ? window() : undefined,
    disableHysteresis: true,
    threshold: 100,
  });

  const handleClick = (event) => {
    const anchor = (event.target.ownerDocument || document).querySelector(
      "#back-to-top-anchor"
    );

    if (anchor) {
      anchor.scrollIntoView({
        block: "center",
      });
    }
  };

  return (
    <Fade in={trigger}>
      <Box
        onClick={handleClick}
        role="presentation"
        sx={{ position: "fixed", bottom: 16, right: 16 }}
      >
        {children}
      </Box>
    </Fade>
  );
}

ScrollTop.propTypes = {
  children: PropTypes.element.isRequired,
  /**
   * Injected by the documentation to work in an iframe.
   * You won't need it on your project.
   */
  window: PropTypes.func,
};

const apiusuario = new apiUsuario();

const ValidarTokenRecaptcha = async (
  tokenGoogleRecaptchaV3,
  ipPublicaValor,
  email,
  navigateToIngresarCodigoRecuperacionClave
) => {
  const respuestaVerificacionRecaptcha = await apigooglerecaptchav3.verificar(
    tokenGoogleRecaptchaV3,
    ipPublicaValor
  );

  if (respuestaVerificacionRecaptcha === true) {
    IngresarConfirmar(email, navigateToIngresarCodigoRecuperacionClave);
  } else {
  }
};

const IngresarConfirmar = async (
  email,
  navigateToIngresarCodigoRecuperacionClave
) => {
  email = email.toLowerCase();

  //obtener codigo de recuperacion
  const response1 = await apiusuario.generarCodigoRecuperacion(email);
  if (response1 === "Ok") {
    //destruir el recaptcha
    if (HabilitarGoogleRecaptcha) ReactRecaptcha3.destroy();

    navigateToIngresarCodigoRecuperacionClave();
  } else {
  }
};

export function OlvidoSuClave(props) {
  const [open, setOpen] = React.useState(false);
  const handleClose = () => {
    setOpen(false);
  };

  const navigate = useNavigate();

  const navigateToIngresarCodigoRecuperacionClave = () => {
    navigate(ENTORNO.URL_APLICACION + "/IngresarCodigoRecuperacionClave");
  };

  const navigateToIngresar = () => {
    navigate(ENTORNO.URL_APLICACION + "/Ingresar");
  };

  const formik = useFormik({
    initialValues: initialValues(),
    validationSchema: validationSchema(),
    validateOnChange: false,
    onSubmit: async (formValue) => {
      try {
        const response = await apiusuario.validarEmail(formik.values.email);

        if (response === "Ok") {
          //muestro back-drop
          setOpen(true);

          setemail(formik.values.email);

          //validacion google recaptcha v3
          //1. calculo ip publica
          const ipPublica = require("react-public-ip");
          const ipPublicaValor = (await ipPublica.v4()) || "";

          //2. obtengo token
          if (HabilitarGoogleRecaptcha) {
            ReactRecaptcha3.getToken().then(
              (tokenGoogleRecaptchaV3) => {
                ValidarTokenRecaptcha(
                  tokenGoogleRecaptchaV3,
                  ipPublicaValor,
                  formik.values.email,
                  navigateToIngresarCodigoRecuperacionClave
                );
              },
              (error) => {
                console.log(error);
              }
            );
          } else {
            IngresarConfirmar(
              formik.values.email,
              navigateToIngresarCodigoRecuperacionClave
            );
          }
        } else {
          Swal.fire({
            title: "Error!",
            text: email_invalido,
            icon: "error",
            confirmButtonText: "Ok",
            confirmButtonColor: estiloColores.Gris,
          });
        }
      } catch (error) {
        console.error(error);
      }
    },
  });

  useEffect(() => {
    if (HabilitarGoogleRecaptcha) {
      ReactRecaptcha3.init(ENTORNO.GOOGLE_RECAPTCHA_V3_SITEKEY).then(
        (status) => {}
      );
    }
  }, []);

  useEffect(() => {
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = "auto";
    };
  }, []);

  return (
    <div style={{ overfxlow: "hidden", touchAction: "none" }}>
      <form onSubmit={formik.handleSubmit}>
        <React.Fragment>
          <CssBaseline />
          <AppBar style={{ background: "#DC030E" }}>
            <Toolbar>
              <IconButton
                size="large"
                edge="start"
                color="inherit"
                onClick={navigateToIngresar}
                aria-label="menu"
                sx={{ mr: 2 }}
              >
                <ArrowBackIcon fontSize="medium" />
              </IconButton>
              <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
                {olvidaste_tu_contrasena}
              </Typography>
              <IconButton
                size="large"
                aria-label="display more actions"
                edge="end"
                color="inherit"
                type="submit"
              >
                <CheckIcon />
              </IconButton>
            </Toolbar>
          </AppBar>
          <Toolbar id="back-to-top-anchor" />
          <Container>
            <Segment style={estiloSegmento.Pasajero}>
              <Grid textalign="center" container style={{ padding: "5em 0em" }}>
                <Grid.Row>
                  <div className="ingresar">
                    <Grid.Column style={{ maxWidth: 450 }}>
                      <Image
                        src={imaLogo}
                        className="logoCrearCuenta"
                        centered
                      />
                      <Header as="h3">
                        {necesitas_ayuda_con_tu_contrasena}
                      </Header>
                      {/* <form
                        size="large"
                        textalign="center"
                        onSubmit={formik.handleSubmit}
                      > */}

                      <Box
                        //component="form"
                        sx={{
                          "& > :not(style)": { m: 1, width: "25ch" },
                        }}
                        noValidate
                        autoComplete="off"
                      >
                        <label>
                          {
                            ingresa_el_correo_electronico_que_utilizas_en_local_point_y_te_ayudaremos_a_crear_una_nueva_contrasena
                          }
                        </label>
                        <br></br>
                        <br></br>
                        <TextField
                          id="password"
                          label={email}
                          placeholder={email}
                          variant="standard"
                          name="email"
                          type="text"
                          icon="key"
                          value={formik.values.email}
                          onChange={formik.handleChange}
                          error={
                            formik.touched.email && Boolean(formik.errors.email)
                          }
                          helperText={
                            formik.touched.email && formik.errors.email
                          }
                        />
                      </Box>
                      {/* </form> */}
                    </Grid.Column>
                  </div>
                </Grid.Row>
              </Grid>
            </Segment>
          </Container>
          <ScrollTop {...props}>
            <Fab size="small" aria-label="scroll back to top">
              <KeyboardArrowUpIcon />
            </Fab>
          </ScrollTop>
        </React.Fragment>
      </form>

      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={open}
        onClick={handleClose}
      >
        <Player
          src={animacion}
          className="player"
          loop
          autoplay
          style={{ height: 110 }}
        />
      </Backdrop>
    </div>
  );
}
